import React, {useState, useEffect, forwardRef, useImperativeHandle} from 'react';
import PropTypes from 'prop-types';
import {Drawer, Divider, Avatar, Form} from 'antd';
import styles from './index.module.less';
import {DoubleLeftOutlined} from '@/icons';

const {Item} = Form;

const UserDetail = forwardRef((props, ref) => {
    const [visible, setVisible] = useState(false);
    const [userInfo, setUserInfo] = useState(null);
    useImperativeHandle(ref, () => ({
        open,
        close,
    }));

    function open(info) {
        console.log('aaaaaaaa', info);
        setUserInfo(info);
        setVisible(true);
    }

    function close() {
        setVisible(false);
    }

    function renderContent() {
        let {avatar, name, joinScene, joinTime, type, gender, mobile} = userInfo;
        return (
            <div>
                <div className={styles.header}>
                    <Avatar src={avatar} className={styles.avatar} />
                    <div className={styles.title}>{name}</div>
                </div>
                <Divider />
                <Form>
                    <Item label="性别：">
                        <div className={styles.value}>{gender == 1 && '男'}</div>
                        <div className={styles.value}>{gender == 2 && '女'}</div>
                    </Item>
                    <Item label="电话：">
                        <div className={styles.value}>{mobile}</div>
                    </Item>
                    <Divider />
                    <Item label="类型：">
                        <div className={styles.value}>{type == 1 && '企业联系人'}</div>
                        <div className={styles.value}>{type == 2 && '微信联系人'}</div>
                    </Item>
                    <Item label="来源：">
                        <div className={styles.value}>{joinScene == 1 && '直接邀请入群'}</div>
                        <div className={styles.value}>{joinScene == 2 && '通过邀请链接入群'}</div>
                        <div className={styles.value}>
                            {joinScene == 3 && '通过扫描群二维码入群'}
                        </div>
                    </Item>
                    <Item label="添加时间：">
                        <div className={styles.value}>{joinTime.substr(0, 10)}</div>
                    </Item>
                </Form>
            </div>
        );
    }

    return (
        <Drawer
            placement="right"
            onClose={() => setVisible(false)}
            visible={visible}
            closeIcon={
                <div className={styles.closeIcon}>
                    <DoubleLeftOutlined /> 收起
                </div>
            }
        >
            {userInfo && renderContent()}
        </Drawer>
    );
});

UserDetail.propTypes = {
    userInfo: PropTypes.object,
    detailVisible: PropTypes.bool,
};

UserDetail.displayName = 'UserDetail';

export default UserDetail;
